export enum MultipleActionsEnum {
    SeparateOrders = 1,
    RestoreOrdersRoute = 2,
    SetOrdersAsStandBy = 3,
    DeliverToPartnerCollection = 4,
    DeliverToPartnerDelivery = 5,
    SetSelectedOrdersLegsAsDispatchable = 6,
    HideOrdersFromPlanning = 7,
    IncludeOrdersInPlanning = 8
};